
export function  isWeixin(){
    return  window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger';
  }

export function  getUrlKey(name){
  return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
} 


export function removeUrlHashParameter(url, parameter) {
  var hashIndex = url.indexOf("#");
  if (hashIndex !== -1) {
    var hash = url.substring(hashIndex + 1);
    for (var param of parameter) {
      var regex = new RegExp("(&|\\?)(" + param + "=[^&]*?)(&|$)", "g");
      hash = hash.replace(regex, "$1");
    }
    hash = hash.replace(/[\?&]+$/, "");
    url = url.substring(0, hashIndex) + "#" + hash;
  }
  return url;
}
